<template>
  <div class="div">123</div>
</template>
<script>
export default {
  name: "Test",
};
</script>
<style  scoped lang='less'>
.div {
  width: 8000px;
  height: 8000px;
}
</style>